import { jsx as _jsx } from "react/jsx-runtime";
import { Column, Columns } from '@dixa/lib-shared-habla';
import { CardsTest } from '../../../components/cardsTest/cardsTest';
export const SettingsIntegrationsCardsShopifyTestView = () => {
    return (_jsx(Columns, { children: _jsx(Column, { children: _jsx(CardsTest, { cardType: "shopify" }) }) }));
};
